import { render, staticRenderFns } from "./single-session.vue?vue&type=template&id=2025dceb&scoped=true&"
import script from "./single-session.vue?vue&type=script&lang=ts&"
export * from "./single-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2025dceb",
  null
  
)

export default component.exports